import type { PersonalInfoFormData } from "@porchpass/ui";
import type { CreateBorrowerFormData } from "src/types/borrower";
import { stripCountryCode } from "src/utils";

export function toPersonalInfoFormData(
  dto: CreateBorrowerFormData,
): PersonalInfoFormData {
  return {
    firstName: dto.first_name ?? "",
    lastName: dto.last_name ?? "",
    middleName: dto.middle_name,
    suffix: dto.suffix,
    email: dto.email ?? "",
    confirmEmail: dto.confirm_email,
    phone: dto.phone_number ? stripCountryCode(dto.phone_number) : "",
    citizenship: "",
  };
}

export function fromPersonalInfoFormData(
  data: PersonalInfoFormData,
): Partial<CreateBorrowerFormData> {
  return {
    first_name: data.firstName,
    last_name: data.lastName,
    middle_name: data.middleName,
    suffix: data.suffix,
    email: data.email,
    confirm_email: data.confirmEmail,
    phone_number: data.phone,
  };
}
